import AUVersionAttributes from 'modules/addons/components/digital-onboarding/PPSRRegistration/forms/versionAttributes/AUVersionAttributes';
import NZVersionAttributes from 'modules/addons/components/digital-onboarding/PPSRRegistration/forms/versionAttributes/NZVersionAttributes';

export { AUVersionAttributes };
export { NZVersionAttributes };
